import { HttpErrorResponse } from '@angular/common/http';
import { ConfiguratorRenewalAction } from '@models';
import { Action, createReducer, on } from '@ngrx/store';
import { GetRenewalActionsFailure, GetRenewalActionsRequest, GetRenewalActionsSuccess } from './actions';

export interface State {
  data: ConfiguratorRenewalAction[] | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const featureKey = 'renewalActions';

export const initialState: State = {
  data: [],
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(GetRenewalActionsFailure, (state, { error }) => ({ ...state, data: [], error, loading: false })),
    on(GetRenewalActionsRequest, state => ({ ...state, error: null, loading: true })),
    on(GetRenewalActionsSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false }))
  )(state, action);
}
